var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "hero"
  }, [_c('b-container', [_c('b-row', [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6",
      "offset-md": "3"
    }
  }, [_c('h1', {
    staticClass: "display-1"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "exclamation-triangle"
    }
  })], 1), _c('h1', [_vm._v("Error 404")]), _c('p', [_vm._v("The page you have requested was not found.")]), _c('div', [_c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "to": '/dashboard',
      "variant": "light"
    }
  }, [_vm._v("Go back to home"), _c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-right"
    }
  })], 1)], 1)])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }